export const EMERGENCY_CONTACT_RELATION_VALUES = [
  "mother",
  "father",
  "sister",
  "brother",
  "guardian",
  "spouse",
] as const;

export type EmergencyContactRelation =
  (typeof EMERGENCY_CONTACT_RELATION_VALUES)[number];

export const emergencyContactRelationOptions: Array<{
  value: EmergencyContactRelation;
  label: string;
}> = [
  { value: "mother", label: "Mother" },
  { value: "father", label: "Father" },
  { value: "sister", label: "Sister" },
  { value: "brother", label: "Brother" },
  { value: "guardian", label: "Guardian" },
  { value: "spouse", label: "Spouse" },
];
